import { jsx as t } from "react/jsx-runtime";
import { forwardRef as d, Suspense as s } from "react";
import { c as a } from "../../index-3527e6f9.js";
import { c as n } from "../../utils-933d6383.js";
const b = a(
  "tw-w-fit tw-py-2 tw-px-4 tw-inline-flex tw-items-center tw-justify-center tw-border tw-whitespace-nowrap tw-rounded-md tw-text-sm tw-font-medium tw-ring-offset-background tw-transition-colors tw-disabled:pointer-events-none tw-disabled:opacity-30 tw-disabled:border-2 tw-disabled:border-white-7 tw-disabled:bg-white-4 tw-disabled:text-white-7",
  {
    variants: {
      variant: {
        blue: "tw-bg-blue-7 tw-text-white-1 tw-font-semibold tw-border-blue-7 focus:tw-border-2 focus:tw-border-white active:tw-border-white focus:tw-shadow-2xl",
        white: "tw-bg-white tw-text-black-1 tw-font-semibold tw-border-white-7 focus:tw-border-2 focus:tw-border-blue-7 focus:tw-text-black focus:tw-shadow-2xl active:tw-shadow-2xl",
        red: "tw-bg-red-1 tw-text-red-7 tw-font-semibold tw-border-red-7 focus:tw-border-2",
        orange: "tw-bg-orange-1 tw-text-orange-7 tw-font-semibold tw-border-orange-7 focus:tw-border-2",
        green: "tw-bg-green-1 tw-text-green-7 tw-font-semibold tw-border-green-7 focus:tw-border-2"
      }
    },
    defaultVariants: {
      variant: "white"
    }
  }
), c = d(
  ({ className: e, variant: r = "white", text: o, ...w }, i) => /* @__PURE__ */ t(s, { fallback: /* @__PURE__ */ t("div", { children: "..." }), children: /* @__PURE__ */ t(
    "button",
    {
      className: n(b({ variant: r, className: e })),
      ref: i,
      ...w,
      children: o
    }
  ) })
);
c.displayName = "Chips";
export {
  c as Chips,
  b as chipsVariants
};
